import Filters from "./Filters";
import ListTemplate from "components/ListTemplate";
import React from "react";
import { routes } from "utilities/routing/generatedRoutes";
import { mapFilterValuesToInstruction, mapResponseToFilterValues } from "./helpers";
import { useLoaderData } from "react-router";

const ProductGroupListApp = () => {
  const viewModel = useLoaderData<server.viewmodel.ProductGroupListFrontModel>();

  return <ListTemplate
    title={RESX.ProductGroup.ProductGroups}
    filterSet="productGroup_List"
    defaultFilters={viewModel.defaultFilters}
    initialInstruction={viewModel.initialInstruction}
    fetchFunction={window.CoreApi.ProductGroup.Paginated}
    getId={item => item.productGroupId}
    layout={{
      type: "table",
      columns: [{
        key: "title",
        header: RESX.GeneralLabels.Title,
        render: item => <a href={routes.productGroup_Detail(item.productGroupId).absolute}>{item.title}</a>,
        size: "1fr"
      }, {
        key: "templateCount",
        header: RESX.ProductTemplate.ProductTemplates,
        render: item => item.productTemplateCount,
        className: "s1_cell_financialamount",
        size: "auto"
      }]
    }}
    filters={<Filters />}
    functions={{
      mapResponseToFilterValues,
      mapFilterValuesToInstruction,
    }}
    onNew={() => window.location.href = routes.productGroup_New().absolute}
  />;
};

export default ProductGroupListApp;